// reactstrap components
import {
  Card,
  CardHeader,
  DropdownMenu,
  UncontrolledDropdown,
  DropdownToggle,
  Container,
  Row,
  Input,
  Button,
  DropdownItem,
  Badge,
} from "reactstrap";
import { useState, useEffect, useRef } from "react";
// core components
import Header from "components/Headers/Header.js";
import { useHistory } from "react-router-dom";

//data
import {
  ORDER_API,
  CHANGE_ORDER_STATUS_API,
  GAMES_API,
  USERS_API,
  AUTO_CONFIRM_API,
  SMILEONE_HEALTHZ
} from "../../services/CONSTANTS";
import {
  getApiDataService,
  postApiDataService,
} from "../../services/apiServices";

import moment from "moment";
import {
  ConfirmDialog,
  DataTable,
  FilterBar,
  StatusBadge,
  TablePagination,
} from "components/shared";

import DateRangePicker from "react-bootstrap-daterangepicker";
import io from "socket.io-client";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import NotificationSound from "../../assets/sound/notification.mp3";
import useDebounce from "./Util/Debounce";
import axios from "axios";

const ORDER_COLUMNS = [
  { key: "index", label: "#" },
  { key: "orderDate", label: "OrderDate", className: "px-1" },
  { key: "game", label: "Game", className: "px-1" },
  { key: "user", label: "User", className: "px-1" },
  { key: "region", label: "Region", className: "px-1" },
  { key: "gameId", label: "GameID", className: "px-1" },
  { key: "zoneId", label: "Zone ID", className: "px-1" },
  { key: "item", label: "Item(or)Unit", className: "px-1" },
  { key: "price", label: "Price", className: "px-1" },
  { key: "status", label: "Status", className: "px-1" },
  { key: "actions", label: "", className: "px-1" },
];

const OrderList = () => {
  const history = useHistory();
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const [orderId, setOrderId] = useState(null);
  let start = moment().startOf("day").toISOString();
  let end = moment().endOf("day").toISOString();
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);
  const [gameID, setGameID] = useState(null);
  const [csUserId, setCsUserId] = useState(null);
  const [search, setSearch] = useState(null);
  const debounceSearch = useDebounce(search, 1000);

  const [gameList, setGameList] = useState([]);
  const [csList, setCSList] = useState([]);

  const [item, setItem] = useState(null);

  const [isShowDeleteConfirmModal, setIsShowDeleteConfirmModal] =
    useState(false);
  
  const [showConfirmModal,setShowConfirmModal] = useState(false)

  const [modal, setModal] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [meta, setMeta] = useState({});

  const [apiUrl, setApiUrl] = useState(null);
  const dispatch = useDispatch();
  const audioPlayer = useRef(null);

  const [dateChangeEvent, setDateChangeEvent] = useState(true);

  let user_id = sessionStorage.getItem("user_id");
  let user_role = sessionStorage.getItem("user_role");

  useEffect(() => {
    let api = ORDER_API + `?sorting=asc&page=${page}&perPage=${perPage}`;
    api += status ? `&status=${status}` : "";
    api += gameID ? `&game_id=${gameID}` : "";
    api += csUserId ? `&cs_user_id=${csUserId}` : "";
    api += debounceSearch ? `&search=${debounceSearch}` : "";

    if (startDate && endDate) {
      api += `&start_date=${startDate}&end_date=${endDate}`;
    }
    console.log("api---", api);

    if (user_role === "CS") {
      setCsUserId(user_id);
      fetchOrderData(api);
    } else {
      fetchOrderData(api);
    }
    setApiUrl(api);
  }, [
    dateChangeEvent,
    page,
    perPage,
    status,
    gameID,
    csUserId,
    debounceSearch,
    user_id,
    user_role,
  ]);

  useEffect(() => {
    fetchGameData();
    fetchCSData();
  }, []);

  useEffect(() => {
    orderSockerHandler();
  }, []);

  const orderSockerHandler = () => {
    const socket = io(process.env.REACT_APP_SOCKET_URL, {
      transports: ["websocket"],
      auth: { token: sessionStorage.getItem("token") },
    });
    socket.on("order-store", (data) => {
      console.log("order-store socket", data);
      let noti_count = 1;
      // dispatch(notiCountHandler(noti_count))
      // dispatch(notiCountHandler(0))
      // toast.info(`You have ${noti_count} new ${data.status} order!`);
      // setOrders((prev) => [data, ...prev]);
      console.log("data.status", data.status);
      console.log("status", status);
      console.log("data.status == status", data.status == status);
      if (orders.length <= perPage && (status == "" || data.status == status)) {
        setOrders((prev) => [...prev, data]);
      }

      audioPlayer.current.play();
    });
  };

  //fetch data
  function fetchOrderData(url) {
    setIsLoading(true);
    getApiDataService(url)
      .then((res) => {
        console.log("res.data", res.data);
        setOrders(res.data);
        setIsLoading(false);
        setMeta(res.meta);
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        setIsLoading(false);
        setOrders([]);
        setMeta({});
      });
    return () => {
      console.log("axios cleanup.");
    };
  }
  function fetchGameData() {
    getApiDataService(GAMES_API)
      .then((res) => {
        setGameList(res.data);
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        setGameList([]);
      });
    return () => {
      console.log("axios cleanup.");
    };
  }

  function fetchCSData() {
    getApiDataService(USERS_API + "?role=CS")
      .then((res) => {
        console.log("res.data", res.data);
        setCSList(res.data);
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        setCSList([]);
      });
  }
  //util
  // Toggle for Modal

  const is_filtering = () => {
    let boo = false;
    let role = sessionStorage.getItem("user_role");
    if (
      role == "ADMIN" &&
      (status || gameID || startDate || endDate || csUserId || debounceSearch)
    ) {
      boo = true;
    }
    if (role == "CS" && (status || gameID || startDate || endDate || debounceSearch)) {
      boo = true;
    }
    return boo;
  };

  const handleReset = () => {
    console.log("reset");
    setOrderId("");
    setGameID("");
    setStatus("");
    setStartDate("");
    setEndDate("");
    setSearch("");
  };
  //handle event process
  let handleStatusChange = (data) => {
    // status = confirmed,pending,rejected
    setIsLoading(true);
    console.log("data", data);
    postApiDataService(CHANGE_ORDER_STATUS_API, data)
      .then((res) => {
        setIsLoading(false);
        handleModalBoxCancel();
        console.log("res.data=", res.data);
        fetchOrderData(apiUrl);
      })
      .catch((err) => {
        console.log("Error in handleStatusChange!", err);
      });
  };
  let handleAutoConfirm = () => {
    // status = confirmed,pending,rejected
    setIsLoading(true);
    axios.get(SMILEONE_HEALTHZ)
    .then((res) => {
      let healthz = res.data?.data
      if(healthz){
        postApiDataService(AUTO_CONFIRM_API, null)
        .then((res) => {
          setIsLoading(false);
          handleModalBoxCancel();
          console.log("res.data=", res.data);
          fetchOrderData(apiUrl);
        })
        .catch((err) => {
          console.log("Error in handleStatusChange!", err);
        });
      }
      else{
        toast.error("SmileOne Server is DownTime!")
        setIsLoading(false);
      }
    })
    .catch((err) => {
      console.log("Error in handleAutoConfirm!", err);
      setIsLoading(false);
      
    });
    


  };

  const handleModalBoxCancel = () => {
    setIsShowDeleteConfirmModal(false);
    setShowConfirmModal(false)
  };
  const handleDelete = (item) => {
    setItem(item);
    setIsShowDeleteConfirmModal(true);
  };

  const handleCallback = (start, end, label) => {
    console.log(start.toISOString(), "startDate1");
    console.log(end.toISOString(), "EndDate2");
    // moment('2020-06-05').format('YYYY-MM-DDTHH:mm:ssZ')
    setStartDate(start.toISOString());
    setEndDate(end.toISOString());

    setDateChangeEvent(!dateChangeEvent);
  };

  const handleGameID = (event) => {
    setGameID(event.target.value);
    console.log("gameID:", gameID);
  };
  const handleStatus = (event) => {
    setStatus(event.target.value);
    console.log("status:", status);
  };

  const handleCSID = (event) => {
    setCsUserId(event.target.value);
    console.log("csUserId:", csUserId);
  };

  const handleSearch = (event) => {
    setSearch(event.target.value);
    console.log("search:", search);
  };

  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7 akh-page-content" fluid>
        {/* Table */}
        <audio ref={audioPlayer} src={NotificationSound} />

        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <FilterBar
                  title="Orders"
                  onClear={handleReset}
                  isFiltering={is_filtering()}
                >
                  <DateRangePicker onCallback={handleCallback}>
                    <input
                      className="form-control akh-filter-width"
                      placeholder="Select date range"
                      aria-label="Date range"
                    />
                  </DateRangePicker>
                  <Input
                    className="akh-filter-select"
                    type="select"
                    value={status ?? ""}
                    onChange={handleStatus}
                    aria-label="Filter by status"
                  >
                    <option value=""> All Status </option>
                    <option value="pending"> Pending </option>
                    <option value="confirmed"> Confirmed </option>
                    <option value="completed"> Completed </option>
                    <option value="rejected"> Rejected </option>
                  </Input>
                  <Input
                    className="akh-filter-select"
                    type="select"
                    onChange={handleGameID}
                    value={gameID ?? ""}
                    aria-label="Filter by game"
                  >
                    <option value=""> All Game </option>
                    {gameList.map((game, index) => {
                      return (
                        <option key={index} value={game.id}>
                          {game.name}
                        </option>
                      );
                    })}
                  </Input>
                  {sessionStorage.getItem("user_role") === "ADMIN" && (
                    <Input
                      className="akh-filter-select"
                      type="select"
                      onChange={handleCSID}
                      value={csUserId ?? ""}
                      aria-label="Filter by CS user"
                    >
                      <option value=""> All CS </option>
                      {csList.map((cs, index) => {
                        return (
                          <option key={index} value={cs.id}>
                            {cs.name}
                          </option>
                        );
                      })}
                    </Input>
                  )}
                  <Input
                    name="orderId"
                    className="akh-filter-width"
                    placeholder="Search"
                    aria-label="Search orders"
                    type="text"
                    value={search ?? ""}
                    onChange={handleSearch}
                  />
                  <Button
                    color="success"
                    onClick={(e) => setShowConfirmModal(true)}
                  >
                    All Topup
                  </Button>
                </FilterBar>
              </CardHeader>
              <DataTable
                className="table-striped"
                columns={ORDER_COLUMNS}
                data={orders}
                isLoading={isLoading}
                emptyMessage="No records found"
                renderRow={(order, index) => (
                  <tr key={order?.id ?? index}>
                    <th>{(meta.page - 1) * meta.perPage + index + 1}</th>
                    <td
                      title={moment(
                        new Date(Date.parse(order?.createdAt))
                      ).fromNow()}
                      style={{ whiteSpace: "wrap" }}
                      className="px-1"
                    >
                      {moment(order?.createdAt).format(
                        "MMMM Do YYYY, h:mm:ss a"
                      )}
                      <br />
                      <Badge color="primary" pill>
                        {moment(
                          new Date(Date.parse(order?.createdAt))
                        ).fromNow()}
                      </Badge>
                    </td>
                    <th className="px-1">{order?.game?.name}</th>
                    <td className="px-1">
                      {order?.user?.name}
                      <br />
                      <span className="ml-1">
                        <Badge color="primary" pill className="font-mono">
                          {order?.user?.userCode}
                        </Badge>
                      </span>
                    </td>
                    <td className="px-1">{order?.region}</td>
                    <td className="px-1 font-mono">{order?.user_game_id}</td>
                    <td className="px-1 font-mono">{order?.zone_id}</td>
                    <td className="px-1">
                      <span className="mb-0 text-lg">
                        <Badge color="primary" pill>
                          {order?.item_name}
                        </Badge>
                      </span>
                    </td>
                    <td className="px-1 font-mono">
                      {order?.price + " " + order?.currency}
                    </td>
                    <td className="px-1">
                      <StatusBadge status={order?.status} />
                    </td>
                    <td className="text-right px-1">
                      <UncontrolledDropdown>
                        <DropdownToggle
                          className="btn-icon-only text-light"
                          href="#pablo"
                          role="button"
                          size="sm"
                          color=""
                          aria-label="Order actions"
                          onClick={(e) => e.preventDefault()}
                        >
                          <i
                            className="fas fa-ellipsis-v"
                            aria-hidden="true"
                          />
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-arrow" right>
                          {order?.status == "pending" ? (
                            <>
                              <DropdownItem
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleStatusChange({
                                    id: order.id,
                                    status: "confirmed",
                                    remark: "",
                                  });
                                }}
                              >
                                Confirmed
                              </DropdownItem>

                              <DropdownItem
                                href="#pablo"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleDelete(order);
                                }}
                              >
                                Rejected
                              </DropdownItem>
                            </>
                          ) : null}
                          {order?.status == "confirmed" ? (
                            <>
                              <DropdownItem
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleStatusChange({
                                    id: order.id,
                                    status: "completed",
                                    remark: "",
                                  });
                                }}
                              >
                                Complete
                              </DropdownItem>

                              <DropdownItem
                                href="#pablo"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleDelete(order);
                                }}
                              >
                                Rejected
                              </DropdownItem>
                            </>
                          ) : null}
                          <DropdownItem
                            href="#pablo"
                            onClick={(e) => e.preventDefault()}
                          >
                            Detail
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </td>
                  </tr>
                )}
              />

              <TablePagination
                meta={meta}
                page={page}
                setPage={setPage}
                perPage={perPage}
                setPerPage={setPerPage}
              />
            </Card>
          </div>
        </Row>
      </Container>

      {isShowDeleteConfirmModal && (
        <ConfirmDialog
          isOpen
          toggle={handleModalBoxCancel}
          title="Are you sure?"
          confirmText="Confirm"
          confirmColor="danger"
          isLoading={isLoading}
          requireRemark={{ label: "Enter Remark" }}
          onConfirm={(remark) =>
            handleStatusChange({
              id: item?.id,
              status: "rejected",
              remark: remark,
            })
          }
        />
      )}

      {showConfirmModal && (
        <ConfirmDialog
          isOpen
          toggle={handleModalBoxCancel}
          title="Confirm"
          message="Are you sure you want to Topup this orders?"
          confirmText="Yes"
          confirmColor="success"
          isLoading={isLoading}
          onConfirm={handleAutoConfirm}
        />
      )}
    </>
  );
};

export default OrderList;
